import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";

// GSAP 플러그인을 전역으로 한 번만 등록
gsap.registerPlugin(useGSAP, ScrollTrigger, MotionPathPlugin);

export { gsap, useGSAP, ScrollTrigger, MotionPathPlugin };
